import { c as _c } from "react/compiler-runtime";
import { SLOW_MODE_UNITS, type SlowModeUnit } from "@/helpers/waves/slow-mode.helpers";
import type { RefObject } from "react";
import WaveSettingEditorActions from "./WaveSettingEditorActions";
interface WaveSlowModeEditorFormProps {
  readonly disabled: boolean;
  readonly inputRef: RefObject<HTMLInputElement | null>;
  readonly isSlowModeEnabled: boolean;
  readonly onCancel: () => void;
  readonly onDisable: () => void;
  readonly onSave: () => void;
  readonly onUnitChange: (unit: SlowModeUnit) => void;
  readonly onValueChange: (value: string) => void;
  readonly unit: SlowModeUnit;
  readonly value: string;
}
const isSlowModeUnit = (value: string): value is SlowModeUnit => SLOW_MODE_UNITS.some(unit => unit === value);
export default function WaveSlowModeEditorForm(t0) {
  const $ = _c(30);
  const {
    disabled,
    inputRef,
    isSlowModeEnabled,
    onCancel,
    onDisable,
    onSave,
    onUnitChange,
    onValueChange,
    unit,
    value
  } = t0;
  let t1;
  if ($[0] !== onSave) {
    t1 = event => {
      event.preventDefault();
      onSave();
    };
    $[0] = onSave;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onValueChange) {
    t2 = event_1 => onValueChange(event_1.target.value);
    $[2] = onValueChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== disabled || $[5] !== inputRef || $[6] !== t2 || $[7] !== value) {
    t3 = <input ref={inputRef} aria-label="Slow mode value" autoFocus={true} className="tw-min-w-0 tw-flex-1 tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-2.5 tw-py-2 tw-text-sm tw-text-iron-100 focus:tw-border-primary-400 focus:tw-outline-none" disabled={disabled} min={1} step={1} type="number" value={value} onFocus={_temp} onChange={t2} />;
    $[4] = disabled;
    $[5] = inputRef;
    $[6] = t2;
    $[7] = value;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onUnitChange) {
    t4 = event_2 => {
      if (isSlowModeUnit(event_2.target.value)) {
        onUnitChange(event_2.target.value);
      }
    };
    $[9] = onUnitChange;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = SLOW_MODE_UNITS.map(_temp2);
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== disabled || $[13] !== t4 || $[14] !== unit) {
    t6 = <select aria-label="Slow mode unit" className="tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-2.5 tw-py-2 tw-text-sm tw-text-iron-100 focus:tw-border-primary-400 focus:tw-outline-none" disabled={disabled} value={unit} onChange={t4}>{t5}</select>;
    $[12] = disabled;
    $[13] = t4;
    $[14] = unit;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t6) {
    t7 = <div className="tw-flex tw-gap-2">{t3}{t6}</div>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = !isSlowModeEnabled;
  let t9;
  if ($[19] !== onDisable || $[20] !== t8) {
    t9 = {
      disabled: t8,
      label: "Disable",
      onClick: onDisable
    };
    $[19] = onDisable;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== disabled || $[23] !== onCancel || $[24] !== t9) {
    t10 = <WaveSettingEditorActions disabled={disabled} onCancel={onCancel} secondaryAction={t9} />;
    $[22] = disabled;
    $[23] = onCancel;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t1 || $[27] !== t10 || $[28] !== t7) {
    t11 = <form className="tw-flex tw-flex-col tw-gap-3" onSubmit={t1}>{t7}{t10}</form>;
    $[26] = t1;
    $[27] = t10;
    $[28] = t7;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}
function _temp2(slowModeUnit) {
  return <option key={slowModeUnit} value={slowModeUnit}>{slowModeUnit}</option>;
}
function _temp(event_0) {
  return event_0.currentTarget.select();
}